import $script from 'scriptjs';

function newToggleHandler(e) {
  e.preventDefault();
  window.Shopify.CustomerAddress.toggleNewForm();
}

export default class StaticAddresses {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.selects = this.el.querySelectorAll('select');

    const scripts = document.querySelector('[data-scripts]');

    $script([scripts.dataset.shopifyCommonUrl],
      () => $script([scripts.dataset.customerAreaUrl],
        () => this._addAddressObservers()));
  }

  _addNewToggles() {
    this.newToggles = this.el.querySelectorAll('[data-customer-toggle-new-form]');

    for (let i = 0; i < this.newToggles.length; i++) {
      this.newToggles[i].addEventListener('click', newToggleHandler);
    }
  }

  _addToggles() {
    const toggleEls = this.el.querySelectorAll('[data-customer-toggle-form]');
    this.toggles = [];

    for (let i = 0; i < toggleEls.length; i++) {
      this.toggles[i] = { el: toggleEls[i] };
      this.toggles[i].handler = (e) => {
        e.preventDefault();
        window.Shopify.CustomerAddress.toggleForm(toggleEls[i].dataset.customerToggleForm);
        toggleEls[i].closest('[data-customer-address]').scrollIntoView();
      };
      toggleEls[i].addEventListener('click', this.toggles[i].handler);
    }
  }

  _addDeletes() {
    const deleteEls = this.el.querySelectorAll('[data-customer-delete-form]');
    this.deletes = [];

    for (let i = 0; i < deleteEls.length; i++) {
      this.deletes[i] = { el: deleteEls[i] };
      this.deletes[i].handler = (e) => {
        e.preventDefault();
        window.Shopify.CustomerAddress.destroy(
          deleteEls[i].dataset.customerDeleteForm,
          this.data.message_confirm_delete,
        );
      };
      deleteEls[i].addEventListener('click', this.deletes[i].handler);
    }
  }

  _getAddressIDs() {
    const addressIDEls = this.el.querySelectorAll('[data-address-id]');
    const addressIDs = [];

    addressIDEls.forEach(addressIDEl => addressIDs.push(addressIDEl.dataset.addressId));

    return addressIDs;
  }

  _addAddressObservers() {
    this.addressIDs = this._getAddressIDs();
    this.addressObservers = [];

    // initialize new address form
    this.addressObservers.push(new window.Shopify.CountryProvinceSelector(
      'address-country',
      'address-province',
      {
        hideElement: 'address-province-container',
      },
    ));

    // initialize edit address form(s)
    this.addressIDs.forEach((id) => {
      this.addressObservers.push(new window.Shopify.CountryProvinceSelector(
        `address-country-${id}`,
        `address-province-${id}`,
        {
          hideElement: `address-province-container-${id}`,
        },
      ));
    });

    this._addNewToggles();
    this._addToggles();
    this._addDeletes();
  }

  onSectionUnload() {
    for (let i = 0; i < this.newToggles.length; i++) {
      this.newToggles[i].removeEventListener('click', newToggleHandler);
    }

    this.toggles.forEach(toggle => toggle.el.removeEventListener('click', toggle.handler));
    this.deletes.forEach(del => del.el.removeEventListener('click', del.handler));
    this.selects.forEach(select => select.unload());
  }
}
